var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#F7801A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2244 14.5581C15.9803 14.8022 15.9803 15.1979 16.2244 15.442C16.4685 15.686 16.8642 15.686 17.1083 15.442L19.3746 13.1756V23.3334C19.3746 23.6785 19.6545 23.9584 19.9996 23.9584C20.3448 23.9584 20.6246 23.6785 20.6246 23.3334V13.1756L22.8911 15.442C23.1351 15.686 23.5309 15.686 23.775 15.442C24.019 15.1979 24.019 14.8022 23.7749 14.5581L20.4416 11.2247C20.3244 11.1075 20.1654 11.0417 19.9996 11.0417C19.8339 11.0417 19.6749 11.1075 19.5577 11.2247L16.2244 14.5581ZM15.2829 17.891C15.4987 17.6216 15.4554 17.2283 15.1861 17.0124C14.9168 16.7965 14.5234 16.8398 14.3075 17.1091C13.3069 18.3573 12.708 19.9429 12.708 21.6667C12.708 25.6938 15.9726 28.9584 19.9997 28.9584C24.0268 28.9584 27.2913 25.6938 27.2913 21.6667C27.2913 19.9429 26.6924 18.3573 25.6918 17.1091C25.4759 16.8398 25.0826 16.7965 24.8132 17.0124C24.5439 17.2283 24.5006 17.6216 24.7165 17.891C25.5457 18.9254 26.0413 20.2373 26.0413 21.6667C26.0413 25.0034 23.3364 27.7084 19.9997 27.7084C16.663 27.7084 13.958 25.0034 13.958 21.6667C13.958 20.2373 14.4536 18.9254 15.2829 17.891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.40293e52ec5cdd94d0dd85ac74d442cc.svg";
export { ForwardRef as ReactComponent };